<template>
  <v-tooltip right v-if="is_latest != undefined && !is_latest && canCreateNewRevision()">
    <template v-slot:activator="{ on }">
      <v-icon color="warning" v-on="on">mdi-alert</v-icon>
    </template>
    <span>There is a newer revision of this content.</span>
  </v-tooltip>
</template>

<script>
import { mapState } from "vuex";
import { mapInjectedData } from "plant-common/src/utils";
import { getCustomId } from "../../../../utils/dbTool";
import { STATE_PERMISSIONS_BY_CATEGORY, STORE_PERMISSIONS_NAME } from "../../../../store_constants/permissions";

export default {
  props: {
    value: Object //card
  },
  inject: ["guideController"],
  computed: {
    ...mapInjectedData("guideController", ["selectedCard"]),
    ...mapState(STORE_PERMISSIONS_NAME, {
      permissionsByCategory: STATE_PERMISSIONS_BY_CATEGORY
    }),
    is_latest() {
      var is_latest;
      if (!this.value.content) is_latest = undefined;
      else {
        var latest_revision =
          this.guideController.latests_revisions[
            getCustomId(this.value.content)
          ];
        var current_revision = `${this.value.content.header.major_revision}.${this.value.content.header.minor_revision}`;

        is_latest = current_revision == latest_revision;
      }
      return is_latest;
    }
  },
  methods: {
		canCreateNewRevision() {
			const permissions = [this.permissionsByCategory.contentManagement.createRevisions]
			return checkUserPermissions(permissions)
		},
		checkUserPermissions(permissions) {
			const hasPermission = permissions.every(permission => this.userPermissions.some(({ codename }) => codename === permission));
			return hasPermission;
		}
  }
};
</script>

<style>
</style>